// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentStatusModal_modalBackdrop__Gcif3 {
  background-color: rgba(26, 36, 31, 0.6) !important;
  backdrop-filter: blur(4px);
}

.PaymentStatusModal_modalContent__rtKfD {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 455px;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.1);
  text-align: center;
  outline: none;
  border: 1px solid #e2e7e3;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .PaymentStatusModal_modalContent__rtKfD {
    width: 95%;
    background: none;
    border: none;
    border-radius: 0;
  }
}

@media (max-width: 767px) {
  .PaymentStatusModal_modalContent__rtKfD .bw-modal-card--status {
    background: #F7F5F1;
    border: none;
  }
}
.PaymentStatusModal_iconWrapper__4rND6 {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  transition: all 0.3s ease;
}

.PaymentStatusModal_icon__HA9aj {
  color: #ffffff;
  font-size: 36px !important;
}

.PaymentStatusModal_title__drFK5 {
  font-size: 24px;
  font-weight: 800;
  color: #1a241f;
  margin: 0 0 12px 0;
  font-family: sans-serif;
}

.PaymentStatusModal_subtitle__r8aE6 {
  font-size: 15px;
  color: #707f75;
  margin: 0 0 32px 0;
  line-height: 1.5;
  font-family: sans-serif;
}

.PaymentStatusModal_actions__lSvGu {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.PaymentStatusModal_button__OQByw {
  width: 100%;
  border: 1px solid #d8dedb;
  background-color: #ffffff;
  color: #1a241f;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-family: sans-serif;
}
.PaymentStatusModal_button__OQByw:hover {
  transform: translateY(-2px);
  background-color: #f8f9f8;
  border-color: #c4cdc8;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.PaymentStatusModal_buttonPrimary__Mz38k {
  background: #4a996d;
  /* Verde institucional */
  color: white;
  border: none;
}
.PaymentStatusModal_buttonPrimary__Mz38k:hover {
  background: #3e835c;
  box-shadow: 0 8px 16px rgba(74, 153, 109, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetails/PaymentStatusModal/PaymentStatusModal.module.scss"],"names":[],"mappings":"AAEA;EACE,kDAAA;EACA,0BAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AADF;AAGE;EAfF;IAgBI,UAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;EAAF;AACF;;AAGA;EACE;IACE,mBAAA;IACA,YAAA;EAAF;AACF;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;AADF;;AAIA;EACE,cAAA;EACA,0BAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,uBAAA;AADF;AAGE;EACE,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,0CAAA;AADJ;;AAKA;EACE,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;AAFF;AAIE;EACE,mBAAA;EACA,+CAAA;AAFJ","sourcesContent":["$breakpoint-md: 767px;\n\n.modalBackdrop {\n  background-color: rgba(26, 36, 31, 0.6) !important;\n  backdrop-filter: blur(4px);\n}\n\n.modalContent {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 455px;\n  background-color: #ffffff;\n  border-radius: 24px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  outline: none;\n  border: 1px solid #e2e7e3;\n  box-sizing: border-box;\n\n  @media (max-width: $breakpoint-md) {\n    width: 95%;\n    background: none;\n    border: none;\n    border-radius: 0;\n  }\n}\n\n@media (max-width: $breakpoint-md) {\n  .modalContent :global(.bw-modal-card--status) {\n    background: #F7F5F1;\n    border: none;\n  }\n}\n\n.iconWrapper {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px auto;\n  transition: all 0.3s ease;\n}\n\n.icon {\n  color: #ffffff;\n  font-size: 36px !important;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 800;\n  color: #1a241f;\n  margin: 0 0 12px 0;\n  font-family: sans-serif;\n}\n\n.subtitle {\n  font-size: 15px;\n  color: #707f75;\n  margin: 0 0 32px 0;\n  line-height: 1.5;\n  font-family: sans-serif;\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n}\n\n.button {\n  width: 100%;\n  border: 1px solid #d8dedb;\n  background-color: #ffffff;\n  color: #1a241f;\n  padding: 14px 24px;\n  font-size: 15px;\n  font-weight: 700;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  font-family: sans-serif;\n\n  &:hover {\n    transform: translateY(-2px);\n    background-color: #f8f9f8;\n    border-color: #c4cdc8;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.buttonPrimary {\n  background: #4a996d;\n  /* Verde institucional */\n  color: white;\n  border: none;\n\n  &:hover {\n    background: #3e835c;\n    box-shadow: 0 8px 16px rgba(74, 153, 109, 0.25);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `PaymentStatusModal_modalBackdrop__Gcif3`,
	"modalContent": `PaymentStatusModal_modalContent__rtKfD`,
	"iconWrapper": `PaymentStatusModal_iconWrapper__4rND6`,
	"icon": `PaymentStatusModal_icon__HA9aj`,
	"title": `PaymentStatusModal_title__drFK5`,
	"subtitle": `PaymentStatusModal_subtitle__r8aE6`,
	"actions": `PaymentStatusModal_actions__lSvGu`,
	"button": `PaymentStatusModal_button__OQByw`,
	"buttonPrimary": `PaymentStatusModal_buttonPrimary__Mz38k`
};
export default ___CSS_LOADER_EXPORT___;
